var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnDestroy, OnInit } from '@angular/core';
import { List } from '../../../../shared/models/list.class';
import { UsersService } from '../../../../services/users.service';
import { RoleTypes } from '../../../../shared/models/users.model';
import { AuthService } from '../../../../services/auth.service';
import { MatDialog } from '@angular/material';
import { FuseTranslationLoaderService } from '../../../../../@fuse/services/translation-loader.service';
import { locale as polish } from '../../../../translations/pl';
import { locale as english } from '../../../../translations/en';
import { FormControl } from '@angular/forms';
import 'rxjs-compat/add/operator/debounceTime';
import { UserEditorComponent } from '../user-editor/user-editor.component';
var UsersListComponent = /** @class */ (function (_super) {
    __extends(UsersListComponent, _super);
    function UsersListComponent(usersService, authService, matDialog, _fuseTranslationLoaderService) {
        var _this = _super.call(this) || this;
        _this.usersService = usersService;
        _this.authService = authService;
        _this.matDialog = matDialog;
        _this._fuseTranslationLoaderService = _fuseTranslationLoaderService;
        _this.displayedColumns = ['avatar', 'name', 'surname', 'email', 'userType', 'roleType', 'companyBranch', 'active'];
        _this.companyBranches = [];
        _this.isAdmin = false;
        _this.listFilters = {};
        _this._fuseTranslationLoaderService.loadTranslations(polish, english);
        _this.reloadList$ = _this.usersService.onEditEvent.subscribe(function () {
            _this.getElementsList();
        });
        _this.loggedUser = _this.authService.getUser();
        if (_this.loggedUser.roleType === RoleTypes.Admin) {
            _this.isAdmin = true;
        }
        _this.getElementsList = function () {
            _this.usersService.getUsersList(_this.getQueryParams()).subscribe(function (res) {
                _this.totalCount = res.totalCount;
                _this.dataSource = res.users;
            });
        };
        return _this;
    }
    UsersListComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.requestParams.sort = 'surname';
        this.createSearchFormControl();
        this.usersService.getCompanyBranchList().subscribe(function (res) {
            res.branches.forEach(function (branch) {
                _this.companyBranches.push({ name: branch.name, value: branch.uuid });
            });
        });
    };
    UsersListComponent.prototype.ngOnDestroy = function () {
        this.reloadList$.unsubscribe();
    };
    UsersListComponent.prototype.clearSearch = function () {
        if (this.searchUser.value) {
            this.searchUser.setValue('');
        }
    };
    UsersListComponent.prototype.getListFilters = function (filters) {
        this.listFilters = filters;
        this.requestParams.page = 1;
        this.disableAnimations = true;
        this.getElementsList();
    };
    UsersListComponent.prototype.addUser = function () {
        this.disableAnimations = true;
        var editorDialogRef = this.matDialog.open(UserEditorComponent, {
            panelClass: 'user-editor-dialog',
            autoFocus: false,
            disableClose: true,
            data: {
                mode: 'add'
            }
        });
    };
    UsersListComponent.prototype.viewUser = function (editedUserUuid) {
        this.disableAnimations = true;
        var editorDialogRef = this.matDialog.open(UserEditorComponent, {
            panelClass: 'user-editor-dialog',
            autoFocus: false,
            disableClose: true,
            data: {
                mode: 'view',
                editedUserUuid: editedUserUuid
            }
        });
    };
    UsersListComponent.prototype.createSearchFormControl = function () {
        var _this = this;
        this.searchUser = new FormControl('');
        this.searchUser.valueChanges.debounceTime(300).subscribe(function (value) {
            _this.requestParams.search = value;
            _this.disableAnimations = true;
            _this.getElementsList();
        });
    };
    UsersListComponent.prototype.getQueryParams = function () {
        return Object.assign({}, this.requestParams, this.listFilters);
    };
    return UsersListComponent;
}(List));
export { UsersListComponent };
